import authService from "./authService";

/** Session key for full list from GET `admin/company/` (no query). */
const SESSION_KEY = "admin_company_list_response_v2";

export function clearAdminCompanyListCache(): void {
  try {
    sessionStorage.removeItem(SESSION_KEY);
  } catch {
    /* ignore */
  }
}

/**
 * Returns full companies list from paginated GET `admin/company/`, using
 * sessionStorage when present; otherwise fetches all pages, stores, and returns.
 */
export async function getAdminCompanyListCached(): Promise<{ companies: unknown[] }> {
  try {
    const raw = sessionStorage.getItem(SESSION_KEY);
    if (raw) {
      const parsed = JSON.parse(raw) as { companies?: unknown[] };
      if (parsed && Array.isArray(parsed.companies)) {
        return { companies: parsed.companies };
      }
    }
  } catch {
    clearAdminCompanyListCache();
  }

  const pageSize = 100;
  let page = 1;
  let hasMore = true;
  const allCompanies: unknown[] = [];

  while (hasMore) {
    const params = new URLSearchParams({
      page: String(page),
      page_size: String(pageSize),
    });
    const response = await authService.get(`admin/company/?${params.toString()}`);
    const data = response.data as { companies?: unknown[]; total?: number; has_next?: boolean };
    const rows = Array.isArray(data?.companies) ? data.companies : [];
    allCompanies.push(...rows);

    if (typeof data?.has_next === "boolean") {
      hasMore = data.has_next;
    } else if (typeof data?.total === "number") {
      hasMore = allCompanies.length < data.total;
    } else {
      hasMore = rows.length === pageSize;
    }
    page += 1;
  }

  const payload = { companies: allCompanies };
  try {
    sessionStorage.setItem(SESSION_KEY, JSON.stringify({ companies: payload.companies }));
  } catch {
    /* quota / private mode */
  }
  return payload;
}
